// extracted by mini-css-extract-plugin
export default {"container":"Login_container__XiMTb","innerBox":"Login_innerBox__Fx8A5","footer":"Login_footer__+j-Rk","error":"Login_error__ByltQ"};